import React, { useState, useContext, useEffect } from 'react';
import { Col } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardSubhead,
} from '@/shared/components/Card';
import toast from 'react-hot-toast';
import Select from 'react-select';
import CryptoJS from 'crypto-js';
import { Button } from '@/shared/components/Button';
import { Table } from '@/shared/components/TableElements';
import { AuthContext } from '../../../../context/AuthContext';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';
import { PermissionContext } from '../../../../context/PermissionContext';

const Manager = () => {
  const { apiGlobal } = useContext(GlobalVarContext);
  const { restaurantid, userid } = useContext(AuthContext);
  const { setPermissionUpdate, setPermissionsAccess } = useContext(PermissionContext);
  const [userName, setUserName] = useState([]);
  const [userId, setUserId] = useState('');
  const [modules, setModules] = useState(['restaurant', 'meal', 'booking', 'account']);
  const [permissions, setPermissions] = useState({});
  const [selectAll, setSelectAll] = useState(false);

  // console.log(restaurantid);
  // console.log(apiGlobal);

  useEffect(() => {
    const newPermissions = {};

    modules.forEach((module) => {
      newPermissions[module] = {
        view: false,
        create: false,
        edit: false,
        delete: false,
        approval: false,
      };
    });
    setPermissions(newPermissions);
  }, [modules]);

  const permissionColors = {
    view: '#007bff',
    create: '#28a745',
    edit: '#ffc107',
    delete: '#dc3545',
    approval: ' #c133ff',
  };

  const fetchUser = async () => {
    const formData = new FormData();
    formData.append('restaurant_id', restaurantid);
    try {
      const response = await fetch(`${apiGlobal}/restaurant/user_restaurant_data.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data?.status && data?.message === 'Success') {
        setUserName(data?.data.map(user => ({ label: user?.name, value: user?.id })));
      } else {
        console.error(data?.message);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

   const fetchPermissions = async () => {
    const formData = new FormData();
    formData.append('id', userid);
    try {
      const response = await fetch(`${apiGlobal}/restaurant/restaurant_permission.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      // console.log(data);
      const secretKey = 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2';
      if (data.status && data.message === 'Success') {
        setPermissionsAccess(data.data[0].permission);
        const permissionss = data?.data[0]?.permission || {};
        setPermissionsAccess(permissionss);
        const permissionsString = CryptoJS.AES.encrypt(JSON.stringify(permissionss), secretKey).toString();
        localStorage.setItem('respermissions', permissionsString);
      } else {
        setPermissionsAccess([]);
      }
    } catch (error) {
      console.error('Error fetching permissions:', error);
      setPermissionsAccess([]);
    }
  };


  const handleCheckboxChange = (module, permission) => {
    setPermissions((prev) => {
      // If changing the view permission
      if (permission === 'view') {
        // Toggle view permission
        const newViewValue = !prev[module][permission];
       
        // If unchecking view, uncheck all other permissions
        if (!newViewValue) {
          return {
            ...prev,
            [module]: {
              view: false,
              create: false,
              edit: false,
              delete: false,
              approval: false,
            },
          };
        }
       
        // If checking view, return updated view permission
        return {
          ...prev,
          [module]: {
            ...prev[module],
            view: newViewValue,
          },
        };
      }
     
      // For other permissions (create, edit, delete)
      // Only allow changes if view is true
      if (!prev[module].view) {
        return prev;
      }
     
      // Toggle other permissions
      return {
        ...prev,
        [module]: {
          ...prev[module],
          [permission]: !prev[module][permission],
        },
      };
    });
  };

  useEffect(() => {
    // console.log('Permissions:', permissions);
  }, [permissions]);

  const fetchUserPermissions = async (e) => {
    setUserId(e.value);
    let fetchedPermissions = [];
    const newPermissions = {};
    const formData = new FormData();
    formData.append('user_id', e.value);
    try {
      const url = `${apiGlobal}/restaurant/restaurant_get_role.php`;
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data?.status && data?.message === 'Success') {
         fetchedPermissions = data?.permissions;
        // console.log('Fetched permissions:', fetchedPermissions);
        modules.forEach((module) => {
          newPermissions[module] = {
            view: fetchedPermissions.includes(`view_${module}`) || false,
            create: fetchedPermissions.includes(`create_${module}`) || false,
            edit: fetchedPermissions.includes(`edit_${module}`) || false,
            delete: fetchedPermissions.includes(`delete_${module}`) || false,
            approval: fetchedPermissions.includes(`approval_${module}`) || false,
          };
        });

        setPermissions(newPermissions);
      } else {
        console.error(data?.message);
        modules.forEach((module) => {
          newPermissions[module] = {
            view: false,
            create: false,
            edit: false,
            delete: false,
            approval: false,
          };
        });
        setPermissions(newPermissions);
      }
    } catch (error) {
      console.error('Error fetching user permissions:', error);
      modules.forEach((module) => {
        newPermissions[module] = {
          view: false,
          create: false,
          edit: false,
          delete: false,
          approval: false,
        };
      });
      setPermissions(newPermissions);
    }
  };

  const saveUserPermissions = async () => {
    try {
      if (!userId) {
        console.error('User not selected');
        return;
      }
  
      const formData = new FormData();
      formData.append('user_id', userId);
  
      const permissionsObject = {
        view: {},
        create: {},
        edit: {},
        delete: {},
        approval: {},
      };
  
      // Populate the permissionsObject with values
      modules.forEach((module) => {
        Object.keys(permissions[module]).forEach((permission) => {
          permissionsObject[permission][module] = permissions[module][permission];
        });
      });
  
      // Append permissions as a JSON string
      formData.append('permissions', JSON.stringify(permissionsObject));
  
    //   // Print FormData for debugging purposes
    Array.from(formData.entries()).forEach(([key, value]) => {
        // console.log(`${key}: ${value}`);
      });
      
  
      // Send the form data to the backend
      const response = await fetch(`${apiGlobal}/restaurant/restaurant_role.php`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await response.json();
  
      if (data?.status && data?.message === 'Permissions updated successfully.') {
        toast.success('Permissions updated successfully!');
        setPermissionUpdate(prev => !prev);
        fetchPermissions();
      } else {
        toast.error(data?.message || 'An error occurred while updating permissions.');
      }
    } catch (error) {
      console.error('Error saving user permissions:', error);
    }
  };

  // Toggle All Permissions (VIEW/CREATE/EDIT/DELETE) for All Modules
  const handleSelectAllPermissions = () => {
    const newState = !selectAll;
    setSelectAll(newState);

    const updatedPermissions = {};
    modules.forEach((module) => {
      updatedPermissions[module] = {
        view: newState,
        create: newState,
        edit: newState,
        delete: newState,
        approval: newState,
      };
    });
    setPermissions(updatedPermissions);
  };

   // NEW: Auto-update SelectAll checkbox if all individual checkboxes are selected
   useEffect(() => {
    const allSelected = modules.every(
      module => Object.values(permissions[module] || {}).every(value => value === true),
    );
    if (selectAll !== allSelected) {
      setSelectAll(allSelected);
    }
  }, [permissions, modules]);

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardSubhead>
              All Users <span className="red-text">Bitevize-Restaurant</span>
            </CardSubhead>
            <Select
              name="userid"
              className="react-select w-25 mt-4"
              classNamePrefix="react-select"
              options={userName}
              placeholder="Select a User"
              onChange={e => fetchUserPermissions(e)}
            />
            {/* === NEW: Select All Permissions Checkbox === */}
            <div className="mt-2 mb-3" style={{ marginLeft: '4px' }}>
              <label 
                htmlFor="selectAllPermission" 
                style={{ 
                  fontWeight: 'bold', 
                  display: 'flex', 
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  gap: '8px', // Adds space between checkbox and text
                  padding: '4px',
                }}
              >
                <input
                  id="selectAllPermission"
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAllPermissions}
                  style={{
                    width: '18px',
                    height: '18px',
                    cursor: 'pointer',
                  }}
                />
                Select All Permissions
              </label>
            </div>
          </CardTitleWrap>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Permission Name</th>
                <th style={{ color: '#007bff' }}>View</th>
                <th style={{ color: '#28a745' }}>Create</th>
                <th style={{ color: '#ffc107' }}>Edit</th>
                <th style={{ color: '#dc3545' }}>Delete</th>
                <th style={{ color: '#c133ff' }}>Approval</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(permissions).map(module => (
                <tr key={module}>
                  <th>{module.charAt(0).toUpperCase() + module.slice(1)}</th>
                  {Object.keys(permissions[module]).map(permission => (
        // Hide approval checkbox for trip module
       (permission === 'approval' && module !== 'account' && module !== 'booking') ? null : (
         <td key={permission}>
           <input
             type="checkbox"
             checked={permissions[module][permission]}
             onChange={() => handleCheckboxChange(module, permission)}
             style={{
                          width: '20px',
                          height: '20px',
                          accentColor: permissionColors[permission] || '#6c757d',
                          cursor: 'pointer',
                        }}
           />
         </td>
                  )
                ))}
                </tr>
              ))}
            </tbody>
          </Table>
          <Button
            style={{ float: 'right', marginTop: '10px' }}
            variant="success"
            size="sm"
            onClick={() => saveUserPermissions()}
          >
            Update Permission
          </Button>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Manager;
